import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'

export const InfoBox = styled(Flex)<{margin?: string;}>`
  width: 100%;
  background-color: ${props => props.theme.colors.shades.neutral[1]};
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;

  ${props => props.margin && css`
    margin: ${props.margin};
  `}
`

export const IconWrapper = styled(Flex)`
  margin: 8px;
  padding: 8px;
  cursor: pointer;
`

export const ContentWrapper = styled.div`
  width: 100%;
  margin: 16px;
  padding: 8px;
  text-align: justify;
`
